import { useIsTeacher } from '@reducers/user/hooks';
import { useQueryClient } from 'react-query';
import React from 'react';
import { toast } from 'react-toastify';
import LearnosityExamsEventEmitter, {
  LearnosityExamsEvents,
  MessageFnType,
  TestletSessionStateUpdateNotificationPayload,
  TestletSessionTimeExtendedNotificationPayload,
} from '../utils/LearnosityExamsEventEmitter';
import Message from '../Components/Message';
import { updateCachedTestletSession } from '../utils/queryHelper';

const useSessionNotification = () => {
  const isTeacher = useIsTeacher();
  const queryClient = useQueryClient();

  React.useEffect(() => {
    const testletSessionResetSubscriber: MessageFnType = (payload) => {
      const testletSessionResetPayload =
        payload as TestletSessionStateUpdateNotificationPayload;
      updateCachedTestletSession(
        queryClient,
        {
          id: testletSessionResetPayload.testlet_session_id,
          ...testletSessionResetPayload,
        },
        testletSessionResetPayload.testlet_id,
      );
      // todo: remove this once we make sure that the invalidation works correctly
      // for demo's sake
      queryClient.invalidateQueries([
        'testletSessions',
        testletSessionResetPayload.testlet_id,
      ]);
      toast.info(
        <Message
          testletId={testletSessionResetPayload.testlet_id}
          sectionId={testletSessionResetPayload.section_id}
          message={`Your administrator has reset your ${testletSessionResetPayload.testlet_name} session`}
          courseId={testletSessionResetPayload?.course_id}
          testSessionId={testletSessionResetPayload.test_session_id}
        />,
        {
          autoClose: false,
        },
      );
    };
    const testletSessionTimeExtendedSubscriber: MessageFnType = (payload) => {
      const testletSessionTimeExtendedPayload =
        payload as TestletSessionTimeExtendedNotificationPayload;
      toast.info(
        <Message
          testletId={testletSessionTimeExtendedPayload.testlet_id}
          sectionId={testletSessionTimeExtendedPayload.section_id}
          message={`Your administrator has extended your ${testletSessionTimeExtendedPayload.testlet_name} session`}
          courseId=""
          testSessionId={0}
        />,
      );
    };
    LearnosityExamsEventEmitter.on(
      LearnosityExamsEvents.TESTLET_SESSION_RESET,
      testletSessionResetSubscriber,
    );
    LearnosityExamsEventEmitter.on(
      LearnosityExamsEvents.TESTLET_SESSION_TIME_EXTENDED,
      testletSessionTimeExtendedSubscriber,
    );
    return () => {
      LearnosityExamsEventEmitter.off(
        LearnosityExamsEvents.TESTLET_SESSION_RESET,
        testletSessionResetSubscriber,
      );
      LearnosityExamsEventEmitter.off(
        LearnosityExamsEvents.TESTLET_SESSION_TIME_EXTENDED,
        testletSessionTimeExtendedSubscriber,
      );
    };
  }, [isTeacher, queryClient]);
};

export default useSessionNotification;
